import * as animationData from '@/assets/animations/loginSuccess.json';
import AnimationWrapper from '../AnimationWrapper';
import { AnimationProps } from '../types';

const LoginSuccess = (props: AnimationProps) => {
  const animationProps = { ...props, animationData };
  return <AnimationWrapper {...animationProps} />;
};

export default LoginSuccess;
